import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProjectsAdressInformation = (
    token: string,
    backend: string,
) => {
    return fetch(
        `${getApiUrl(backend)}adressinformation`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getProjectsAdressInformation;